var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { attr } from '@ember-data/model';
import { computed } from '@ember/object';
import EmberDataBaseFragment from '@square/dashboard-data/models/ember-data-base-fragment';
import allowDeprecatedOverrides from '@square/dashboard-utilities/utils/compat/allow-deprecated-overrides';
import { dependentKeyCompat } from '@ember/object/compat';
import { inject as service } from '@ember/service';
let ItemModifierOptionOverride = (_dec = attr('boolean'), _dec2 = attr('boolean'), _dec3 = attr('string'), _dec4 = computed('isNew', 'onByDefault', {
  get() {
    const hasDirtyAttributes = Object.keys(this.changedAttributes()).length > 0;
    return hasDirtyAttributes && !this.isNew;
  }
}), (_class = class ItemModifierOptionOverride extends EmberDataBaseFragment {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "onByDefault", _descriptor, this);
    _initializerDefineProperty(this, "hiddenOnline", _descriptor2, this);
    _initializerDefineProperty(this, "itemModifierOptionId", _descriptor3, this);
    _initializerDefineProperty(this, "store", _descriptor4, this);
    _initializerDefineProperty(this, "isDirty", _descriptor5, this);
  }
  // this can be converted to a getter, will require updating the item duplication test
  get itemModifierOption() {
    return this.itemModifierOptionId ? this.store.peekRecord('item-modifier-option', this.itemModifierOptionId) : null;
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "onByDefault", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "hiddenOnline", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "itemModifierOptionId", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "itemModifierOption", [dependentKeyCompat, allowDeprecatedOverrides], Object.getOwnPropertyDescriptor(_class.prototype, "itemModifierOption"), _class.prototype), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "isDirty", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class));
export { ItemModifierOptionOverride as default };
ItemModifierOptionOverride.reopenClass({
  _modelNameForMigration: 'item-modifier-option-override',
  // Return true if this option override is equivalent to not having an override
  isDefault(override) {
    return override.onByDefault === false;
  }
});